import { useLazyQuery } from "@apollo/client";
import React, { createContext, useContext, useEffect, useState } from "react";
import { FSP_WALLET } from "../GraphApi/EqupPlans/Plan";
import { currentTeamId, hasAffiliate } from "../Utils/utils";
import { AuthContext } from "./AuthContext";

export const MyWalletContext = createContext(null);

export const MyWalletProvider = ({ children }) => {
  const [walletAmount, setWalletAmount] = useState(0);
  const [error, setError] = useState(null);

  const { userData } = useContext(AuthContext);

  const [getWallet] = useLazyQuery(FSP_WALLET, {
    fetchPolicy: "network-only",
  });

  useEffect(() => {
    if (userData?.authenticated && !hasAffiliate(userData) && currentTeamId) {
      fetchWallet();
    }
  }, [userData, currentTeamId]);

  const fetchWallet = (type = "user") => {
    getWallet({
      variables: { team_id: currentTeamId, type: type },
      fetchPolicy: "network-only",
    })
      .then((result) => {
        if (result?.data?.getWallet?.credit > 0) {
          setWalletAmount(parseFloat(result.data.getWallet.credit, 2));
        } else {
          setWalletAmount(0);
        }
      })
      .catch((error) => {
        let { graphQLErrors } = error;
        setError(error);
        // handleAlertMessage(
        //   "error",
        //   checkErrorExists(getValidationMessage(graphQLErrors), locale)
        // );
      });
  };

  const value = {
    walletAmount: walletAmount,
    fetchWallet: fetchWallet,
    walletError: error,
  };

  return (
    <MyWalletContext.Provider value={value}>
      {children}
    </MyWalletContext.Provider>
  );
};
